export const version = "abstract-signer/5.0.9";
//# sourceMappingURL=_version.js.map